import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";

/**
 * フェイクテーブルのリスト
 */
const fakeTableList: ITkFakeTableLineProps[] = [
  {
    title: "施設を選択",
    keyword: "facilityName",
    type: "selectForm",
    placeholder: "選択ください",
    requiredIcon: true,
  },
  {
    title: "訂正する項目を選択",
    keyword: "fixColumn",
    type: "radio",
    requiredIcon: true,
    radioPropsList: [
      { label: "措置入所障害児関係業務従事職員数", value: "1" },
      { label: "特定職員数", value: "2" },
    ],
  },
  {
    keyword: "title1",
    type: "lineTitle",
    lineTitle: "変更前",
  },
  {
    title: "特定職員数（見込数）",
    keyword: "bSpecificStaffNum",
    type: "text",
    showLine: false,
  },
  {
    title: "措置入所障害児関係業務従事職員数（見込数）",
    keyword: "bHcStaffNum",
    type: "text",
  },
  {
    keyword: "title2",
    type: "lineTitle",
    lineTitle: "変更後",
  },
  {
    title: "特定職員数",
    keyword: "aSpecificStaffNum",
    type: "inputWithText",
    innerText: "人",
    onlyNumber: true,
    useNumberValue: true,
    inputProps: { maxLength: 3 },
    requiredIcon: true,
    showLine: false,
  },
  {
    title: "措置入所障害児関係業務従事職員数",
    keyword: "aHcStaffNum",
    type: "inputWithText",
    innerText: "人",
    onlyNumber: true,
    useNumberValue: true,
    inputProps: { maxLength: 3 },
    requiredIcon: true,
  },
  {
    keyword: "title2",
    type: "lineTitle",
    lineTitle: "",
  },
  {
    title: "備考",
    keyword: "remark",
    type: "label",
    inputProps: { maxLength: 85 },
  },
];
const schema = {
  facilityName: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
  fixColumn: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
  },
  aHcStaffNum: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    max: {
      value: 999,
      message: TkPropertyMessageGet("TKMSG_SCR0048E", "999"),
    },
  },
  remark: {
    pattern: {
      // eslint-disable-next-line no-control-regex
      value: /^[^\x00-\x08\x0B\x0C\x0E-\x1F\x7F -~｡-ﾟ]+$/,
      message: TkPropertyMessageGet("TKMSG_SCR0061E"),
    },
  },
};

const schemaTwo = {
  facilityName: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
  fixColumn: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
  },
  aSpecificStaffNum: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    max: {
      value: 999,
      message: TkPropertyMessageGet("TKMSG_SCR0048E", "999"),
    },
  },
  remark: {
    pattern: {
      // eslint-disable-next-line no-control-regex
      value: /^[^\x00-\x08\x0B\x0C\x0E-\x1F\x7F -~｡-ﾟ]+$/,
      message: TkPropertyMessageGet("TKMSG_SCR0061E"),
    },
  },
};

export { schema, fakeTableList, schemaTwo };
